import { useEffect } from "react";
import Header from "../../components/feature/Header";
import PageSEO from "../../components/feature/PageSEO";
import HeroSection from "./components/HeroSection";
import StatsSection from "./components/StatsSection";
import ImageGallerySection from "./components/ImageGallerySection";
import WildfireSection from "./components/WildfireSection";
import TPATechSection from "./components/TPATechSection";
import ComparisonSection from "./components/ComparisonSection";
import WasteFreeSection from "./components/WasteFreeSection";
import BenefitsSection from "./components/BenefitsSection";
import TestimonialsSection from "./components/TestimonialsSection";
import XSeriesSection from "./components/XSeriesSection";

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const homeJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Airdog - Medical-Grade Air Purification Without Filter Replacements",
  "description": "Protect your home from wildfire smoke and airborne pollutants with Airdog TPA technology. 99.9% destruction rate, washable plates, no filter replacements needed.",
  "url": siteUrl,
  "about": {
    "@type": "Product",
    "name": "Airdog Air Purifier",
    "description": "Medical-grade air purifier using TPA (Two-Pole Active) technology that destroys 99.9% of airborne pollutants including wildfire smoke, allergens, bacteria, and viruses — with washable plates and zero disposable filter replacements.",
    "brand": {
      "@type": "Brand",
      "name": "Airdog"
    },
    "category": "Air Purifier"
  },
  "isPartOf": {
    "@type": "WebSite",
    "name": "Airdog",
    "url": siteUrl
  }
};

export default function Home() {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const id = hash.slice(1);
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => {
          const headerOffset = 80;
          const top = el.getBoundingClientRect().top + window.scrollY - headerOffset;
          window.scrollTo({ top, behavior: "smooth" });
        }, 300);
      }
    }
  }, []);

  return (
    <div className="min-h-screen">
      <PageSEO jsonLd={homeJsonLd} />
      <Header />
      <main className="pt-16">
        <HeroSection />
        <ImageGallerySection />
        <WildfireSection />
        <TPATechSection />
        <StatsSection />
        <WasteFreeSection />
        <ComparisonSection />
        <BenefitsSection />
        <TestimonialsSection />
        <XSeriesSection />
      </main>
    </div>
  );
}